import { Button } from "@mui/material";
import * as React from "react";
import { useIsMobile } from "../hooks/useIsMobile";

const GoogleSignIn = () => {
  // Initiate mobile check
  const isMobile = useIsMobile();

  const initiateGoogleLogin = (e) => {
    // PREVENT SIDEBAR FROM CLOSING?INTERRUPTING
    // Stop the click from reaching the Sidebar/Drawer parents
    e.stopPropagation();

    // Grab the URL (Freshly read from env)
    const apiUrl = process.env.REACT_APP_API_URL;
    const target = `${apiUrl}/oauth2/authorization/google`;

    window.location.assign(target);
  };

  // TODO: catch this and write an error message http://localhost:3000/?error=oauth_failed

  return (
    <Button
      variant="contained"
      sx={{
        height: isMobile ? "96px" : "64px",
        width: "100%",
        justifySelf: "center",
      }}
      onClick={initiateGoogleLogin}
    >
      Sign In
    </Button>
  );
};

export default GoogleSignIn;
